import { css } from "@emotion/react";
import { gridClasses } from "@mui/x-data-grid-premium";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const container = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
`;

export const grid =
  ({
    hideToolbar,
    appliedFilterColumns,
  }: {
    hideToolbar: boolean;
    appliedFilterColumns: string[];
  }) =>
  (theme: ExactTheme) =>
    css({
      [`&.${gridClasses.root}`]: {
        "--DataGrid-rowBorderColor": theme.colorsV2.grey[100],
        overflow: "hidden",
        borderColor: theme.colorsV2.grey[100],
        borderRadius: 6,
      },
      ...appliedFilterColumns.reduce((acc, column) => {
        return {
          ...acc,
          [`& .${gridClasses.columnHeader}[data-field="${column}"]`]: {
            backgroundColor: theme.colorsV2.orange[25] + "!important",
          },
        };
      }, {}),

      marginTop: hideToolbar ? 0 : "10px",
      [`& .${gridClasses.row}`]: {
        cursor: "pointer",
      },
    });
